import { applyMiddleware, combineReducers, compose, createStore } from "redux";

import { thunk } from "redux-thunk";
import collapsibleTableChart from "../ducks/collapsibleTableChart";
import confirmDialog from "../ducks/confirmDialog";
import country from "../ducks/country";
import forgotPassword from "../ducks/forgotPassword";
import fundingArea from "../ducks/fundingArea";
import indicatorList from "../ducks/indicatorAdmin";
import indicatorGroup from "../ducks/indicatorGroup";
import indicatorManagament from "../ducks/indicatorManagament";
import languageSelector from "../ducks/languageSelector";
import lectorateType from "../ducks/lectorateType";
import loading from "../ducks/loadingSpinner";
import login from "../ducks/login";
import manageSurveyTempUsers from "../ducks/manageSurveyTempUsers";
import maintenance from "../ducks/maintenance";
import masterData from "../ducks/masterData";
import message from "../ducks/message";
import questionLibrary from "../ducks/questionLibrary";
import region from "../ducks/regions";
import report from "../ducks/report";
import reportActivation from "../ducks/reportActivation";
import respondentsOverview from "../ducks/respondentsOverview";
import role from "../ducks/role";
import statusOfSurvey from "../ducks/statusOfSurvey";
import survey from "../ducks/survey";
import surveyEditor from "../ducks/surveyEditor";
import surveyRunner from "../ducks/surveyRunner";
import surveySettings from "../ducks/surveySettings";
import surveyView from "../ducks/surveyView";
import templateActivation from "../ducks/templateActivation";
import templatelist from "../ducks/templatelist";
import university from "../ducks/university";
import user from "../ducks/user";
import userManagement from "../ducks/userManagement";
import userProfile from "../ducks/userProfile";
import {
  COUNTRY_STORE,
  FORGOT_PASSWORD_STORE,
  FUNDING_AREA_STORE,
  INDICATOR_MANAGEMENT_STORE,
  LANGUAGE_SELECTOR,
  LECTORATE_TYPE_STORE,
  LOGIN_STORE,
  MASTER_DATA_STORE,
  QUESTION_LIBRARY_STORE,
  REGION_STORE,
  REPORT_ACTIVATION,
  ROLE_STORE,
  SURVEY,
  SURVEY_EDITOR,
  SURVEY_VIEW_STORE,
  UNIVERSITY_STORE,
  USER_MANAGEMENT_STORE,
  USER_PROFILE
} from "./constant";

const reducers = {
  message,
  [LOGIN_STORE]: login,
  maintenance,
  loading,
  respondentsOverview,
  [SURVEY]: survey,
  [REPORT_ACTIVATION]: reportActivation,
  surveySettings,
  templatelist,
  templateActivation,
  indicatorList,
  indicatorGroup,
  confirmDialog,
  [LANGUAGE_SELECTOR]: languageSelector,
  [SURVEY_EDITOR]: surveyEditor,
  surveyRunner,
  [SURVEY_VIEW_STORE]: surveyView,
  [FUNDING_AREA_STORE]: fundingArea,
  manageSurveyTempUsers,
  [USER_MANAGEMENT_STORE]: userManagement,
  statusOfSurvey,
  user,
  report,
  collapsibleTableChart,
  [QUESTION_LIBRARY_STORE]: questionLibrary,
  [MASTER_DATA_STORE]: masterData,
  [UNIVERSITY_STORE]: university,
  [COUNTRY_STORE]: country,
  [REGION_STORE]: region,
  [LECTORATE_TYPE_STORE]: lectorateType,
  [ROLE_STORE]: role,
  [USER_PROFILE]: userProfile,
  [FORGOT_PASSWORD_STORE]: forgotPassword,
  [INDICATOR_MANAGEMENT_STORE]: indicatorManagament
};

const composeEnhancers =
  process.env.NODE_ENV !== "production" ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

const store = createStore(combineReducers(reducers), composeEnhancers(applyMiddleware(thunk)));

export default store;
